<template>
    <div>
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="20">
                <div class="title">
                    <h1>AR assisted assembly system</h1>
                </div>
                <div class="video">
                    <div class="">
                        <video src="../assets/ar.mp4" controls muted >
                        OMG! Where is my video?
                        </video>
                    </div>
                </div>
                <div class="abstract">
                    Design and develop augmented reality based auxiliary systems for AVIC Xi'an Aircraft Industry Group Company LTD, AVIC Changhe Aircraft Industry Group  Company LTD, and AVIC Shaanxi Aircraft Industry Group  Company LTD.
                    <br><br> The specific content cannot be disclosed temporarily
                </div>            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>

    </div>
</template>

<script>
    export default {
        name: "Project1"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>